import { FaLayerGroup, FaPalette, FaCode } from "react-icons/fa6";
import images from "./images";

const About = {
  sub: "About Us",
  heading: "Creating Templates That Power Modern Websites",
  description:
    "We design and develop high-quality HTML and React templates to help developers, startups, and businesses launch faster with clean, modern, and fully responsive designs.",

  points: [
    {
      icon: <FaLayerGroup />,
      title: "Fully Responsive",
      content:
        "Templates that work perfectly across all devices, ensuring a seamless user experience everywhere.",
    },
    {
      icon: <FaPalette />,
      title: "Modern UI Design",
      content:
        "Clean, stylish, and user-friendly designs built to match modern web trends.",
    },
  ],

  image: {
    src1: images.about1,
    src2: images.about2,
    src3: images.about3,
    src4: images.about4,
    alt1: "Template Preview 1",
    alt2: "Template Preview 2",
    alt3: "Template Preview 3",
    alt4: "Template Preview 4",
    experience: {
      years: "50+",
      title: "Templates Created",
      icon: <FaCode />,
    },
  },

  button: {
    text: "Explore Templates",
    link: "Website-Templates",
  },
};

export default About;